import { stats } from '@fiverr-private/obs';
import { APP_NAME } from '../../../configuration/constants';

export const METRIC_PREFIX = `services.${APP_NAME}`;

/**
 * The current service prefixed stats instance.
 */
export const metric = stats.prefix(METRIC_PREFIX);
